import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'article-cta-block',
  styleUrl: 'article-cta-block.css',
  shadow: true,
})
export class ArticleCtaBlock {
  /**
   * The title
   */
  @Prop() mainTitle: string;

  /**
   * Button Data
   */
  @Prop() buttonsData: string;


  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  // private getText(): string {
  //   return format(this.first, this.middle, this.last);
  // }

  render() {
    //console.log('data', this.imageUrl);
    const buttons = JSON.parse(this.buttonsData);
    return (
      <Host>
        <div class={`article-container justify-center ${this.paddingBottom} ${this.paddingTop}`} style={{ backgroundImage: `url(${this.backgroundImage})` }}>
          <div class={`${this.backgroundColor} flex flex-col items-center rounded-xl py-140px px-16px`}>
            {this.mainTitle ? <h2 class={`fs-4 text-center text-white font-semibold ${this.textColor}`}>{this.mainTitle}</h2> : null}
            {buttons && buttons.length > 0 && (
              <div class="flex gap-12px mt-32px">
                {buttons.map(button => (
                  <button-block buttonsData={button}></button-block>
                ))}
              </div>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
